import React, { useState } from 'react'
import { useHistory } from 'react-router-dom';
import sendEventToEventLogs from '../helpers/events';

function getBaseUrl(){
	if(window.location.hostname=='localhost')
		return ('http://localhost:8081')
	else if(window.location.hostname.includes('preprod'))
		return ('https://patientwebappbackend-preprod.medibuddy.in')
	else
		return (window.location.origin);

}
function getKey (){
	if(getBaseUrl().includes('affinity.medibuddy.in')){
    	return process.env.REACT_APP_RAZORPAY_LIVE_SECRET_KEY
	}
	else 
	return process.env.REACT_APP_RAZORPAY_TEST_SECRET_KEY

}
function loadScript(src) {
	return new Promise((resolve) => {
		const script = document.createElement('script')
		script.src = src
		script.onload = () => {
			resolve(true)
		}
		script.onerror = () => {
			resolve(false)
		}
		document.body.appendChild(script)
	})
}

const __DEV__ = document.domain === 'localhost'


	async function addUser(packageId,packageName,price, values,master_policy_no
									,pmEntityId,members,walletAmount, baseURl, additionalMemberData) {
		
		const obj={paymentSuccess:false
			,transactionId:null
			,message:null};
		try{
		
		
		
			
		const requestBody={
			
			master_policy_no:master_policy_no,
			master_policy_holder: 'Medibuddy',   
			proposer_name: values.name,
			phonenumber: values.mobile,
			email: values.email,
			policy_start: new Date(),
			no_of_members: (members)?members:1,
			policy_tenure: "1 Year",
			policy_sum_insured: (values.sum_insured)?values.sum_insured:null,
			packageId:packageId,
			passcode:values.passcode,
            vendor: localStorage.getItem('source'),
            pmEntityId:pmEntityId,
			additionalMemberData: additionalMemberData ? JSON.stringify(additionalMemberData) : null
			
			
			
		}
		const requestOptionsFormContent= {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(requestBody)
		};
		
		const confirmationData = await fetch(getBaseUrl()+'/patientswebapp/affinity/addAffinityUserWithPasscode'
						,requestOptionsFormContent)
						.then((t) =>
						   t.json()

		)
		
	
                obj.paymentSuccess=true;
				console.log("jsonConfirmData"+JSON.stringify(confirmationData))
				sendEventToEventLogs("AFFINITY_PAYMENT_SUCCESSFUL",{packageId:packageId})
				if(confirmationData.success==1){
					obj.message ="Benefits Added For User, Please check your email. "
				}
                else if(confirmationData.error=='Passcode is mandatory') {
					obj.message ="Could Not Add Benefits for User ->"+confirmationData.error
				}
				else if(confirmationData.error=='Email/Phonenumber is mandatory') {
					obj.message ="Could Not Add Benefits for User ->"+confirmationData.error
				}
                else  {
					obj.message ="Could Not Add Benefits for User, Try Later"
				}
               
				alert(obj.message);
                window.location.replace((baseURl ? baseURl : '/home') + '?utm_source='+localStorage.getItem("source"));
			
	}			
			catch(e){
				console.log("e"+e)
				obj.message="Cannot Process Your request at this time, Please try again "; 
				alert(obj.message);
				
				return obj;
			}
	}    

    export  {addUser,getBaseUrl};
